import script from "./SelectBrandsStep.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectBrandsStep.vue?vue&type=script&setup=true&lang=js"

import "./SelectBrandsStep.vue?vue&type=style&index=0&id=0737401f&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0737401f"]])

export default __exports__